<template>
  <div>
    <search-form
      :fetchData="fetch"
      ref="searchFormRef"
      :handelSearch="handelSearch"
      :collection="formCollection"
      :addBtn="false"
      :ableSearch="ableSearch"
    ></search-form>
    <a-table
      :columns="columns"
      :row-key="(record) => record.uuid"
      :data-source="tableData"
      :pagination="pagination"
      :loading="loading"
      @change="handleTableChange"
      :customRow="handleRow"
      size="small"
    >
      <template #bodyCell="{ column, record }">
        <template v-if="column.key === 'image'">
          <a-image
            :width="55"
            :src="record.image_url"
          />
        </template>
        <template v-else-if="column.key === 'device_name'">
          <span>{{ record.device?.name || '-' }}</span>
        </template>
        <table_data_format
          v-else
          :record="record"
          :column="column"
        ></table_data_format>
      </template>
    </a-table>

    <!-- 详情对话框 -->
    <a-modal
      v-model:visible="detailModalVisible"
      title="人员预约记录"
      :width="800"
      :footer="null"
      destroyOnClose
    >
      <action
        :v-if="detailModalVisible"
        @submit="clickOk"
        :editData="detailData"
        :data="tableData"
        idField="person_application_id"
        :disabled="true"
      ></action>
    </a-modal>
  </div>
</template>
<script setup>
  import { ref, onMounted, toRefs, computed } from 'vue'
  import { useStore } from 'vuex'
  import action from './action'
  import { getPerson as getData, queryPersonApplicationRecord } from '@/api/gate_crossing_records'
  import searchForm from '@/components/search_form'
  import dayjs from 'dayjs'
  import { codeToText, constantToOptions } from '@/utils/format'
  import table_data_format from '@/components/table_data_format'
  import { gateCrossingResult } from '@/utils/common'
  import { message } from 'ant-design-vue'

  const eventTypeOption = [
    {
      "label": "入园",
      "value": 1
    },
    {
      "label": "出园",
      "value": 2
    }
  ];

  //初始化
  const store = useStore()
  const Enum = toRefs(store.state.common)

  const permissionList = computed(() => store.getters['user/permissionList'])
  const ableSearch = computed(() =>
    !!permissionList.value?.find(item => item.code === 'personGateCrosRecords:list')
  )

  //1、搜索框
  const formCollection = [
    {
      type: 'input',
      field: 'idCard',
      label: '证件号码',
      'allow-clear': true,
    },
    {
      type: 'input',
      field: 'personName',
      label: '姓名',
      'allow-clear': true,
    },
    {
      type: 'select',
      field: 'eventType',
      label: '进出类型',
      width: '80px',
      // defaultValue: 1,
      options: eventTypeOption,
      'allow-clear': true,
    },
    {
      type: 'select',
      field: 'openResult',
      label: '开门结果',
      width: '80px',
      // defaultValue: 1,
      options: constantToOptions(gateCrossingResult),
      'allow-clear': true,
    },
    {
      type: 'select',
      field: 'visitArea',
      storeOptions: 'areaType',
      defaultValue: 3,
      label: '园区类型',
      width: '130px',
    },
    {
      type: 'dateRange',
      startField: 'startDate',
      endField: 'endDate',
      defaultStart: dayjs().format('YYYY-MM-DD'),
      defaultEnd: dayjs().format('YYYY-MM-DD'),
      label: '日期',
    },
  ]
  const searchFormRef = ref()
  function handelSearch() {
    pagination.value.current = 1
    fetch()
    const params = {
      ...searchFormRef.value.formState
    }
    store.commit('search/setGatePerson', params)
  }

  //2、表格
  const columns = [
    {
      title: '日期',
      dataIndex: 'date',
      key: 'date',
      align: 'left',
    },
    {
      title: '姓名',
      dataIndex: 'person_name',
      key: 'person_name',
      align: 'left',
    },
    {
      title: '证件号',
      dataIndex: 'paper_number',
      key: 'paper_number',
      align: 'left',
    },
    {
      title: '访客类型',
      key: 'crossing_image_type',
      align: 'left',
    },
    {
      title: '卡状态',
      key: 'crossing_card_status',
      align: 'left',
    },
    {
      title: '卡号',
      key: 'card_number',
      align: 'left',
    },
    {
      title: '进出类型',
      key: 'person_event_type',
      align: 'left',
    },
    {
      title: '设备名称',
      dataIndex: 'device_name',
      key: 'device_name',
      align: 'left',
    },
    {
      title: '开门结果',
      key: 'open_result',
      dataIndex: 'open_result',
      align: 'left',
    },
    {
      title: '图片',
      key: 'image',
      align: 'left',
    },
    {
      title: '抓拍时间',
      dataIndex: 'capture_time',
      key: 'capture_time',
      align: 'left',
    },
  ]

  const tableData = ref([])
  const loading = ref(false)
  const loadingRecord = ref()
  const pagination = ref({
    current: 1,
    pageSize: 10,
    showLessItems: true,
    showQuickJumper: true,
    showSizeChanger: true,
    showTotal: (total, range) => {
      return `共 ${total} 条`
    },
  })

  function handleTableChange(page) {
    pagination.value = { ...pagination.value, ...page }
    fetch()
  }

  function fetch() {
    //获取表单值
    const formState = searchFormRef.value?.formState

    loading.value = true
    getData({
      size: pagination.value.pageSize,
      pn: pagination.value.current,
      ...formState,
    }).then(({ data }) => {
      loading.value = false
      // data.list = [{
			// 	"date": "2025-12-18",
			// 	"id": "1451238372688535552",
			// 	"card_number": "",
			// 	"card_status": 0,
			// 	"device_id": "1000184",
			// 	"channel_id": "1000184$7$0$0",
			// 	"event_type": 1,
			// 	"image_url": "https://dywvrs.com/dhproxy/evo-pic/f24b52eb-5ca7-11f0-a2ee-e8611f3e0797/20251218/1/dsf_c9a5cfbd-dbe4-11f0-8a17-e8611f3e0797_30803368_30828229.jpg?token=3:pQ9XN5FSde3XmHvqpDn9eYqDehK4tacI&oss_addr=44.92.89.1:8925",
			// 	"image_type": 1,
			// 	"open_result": 1,
			// 	"open_type": 61,
			// 	"person_name": "金济",
			// 	"paper_number": "421123198903117214",
			// 	"capture_time": "2025-12-18 15:43:10",
			// 	"create_time": "2025-12-18 15:43:18",
			// 	"insert_time": "2025-12-18 15:43:17",
			// 	"device": {
			// 		"id": "441399110983464623",
			// 		"name": "东门人员进园2",
			// 		"number": "1000184",
			// 		"longitude": "0.000000",
			// 		"latitude": "0.000000",
			// 		"type": 2,
			// 		"is_security_check": 0,
			// 		"state": 1,
			// 		"entrances_type": 1,
			// 		"state_update_time": "2025-12-18 01:00:09",
			// 		"lane_number": 0,
			// 		"create_user_id": "0",
			// 		"update_user_id": "0",
			// 		"create_time": "2025-03-26 01:00:04",
			// 		"update_time": "2025-03-26 01:00:04",
			// 		"deleted": 0,
			// 		"access_type": 1
			// 	}
			// },
			// {
			// 	"date": "2025-12-18",
			// 	"id": "1451238322365276160",
			// 	"card_number": "",
			// 	"card_status": 0,
			// 	"device_id": "1000184",
			// 	"channel_id": "1000184$7$0$0",
			// 	"event_type": 1,
			// 	"image_url": "https://dywvrs.com/dhproxy/evo-pic/f24b52eb-5ca7-11f0-a2ee-e8611f3e0797/20251218/1/dsf_c9a5cfbd-dbe4-11f0-8a17-e8611f3e0797_24446988_24470112.jpg?token=3:pQ9XN5FSde3XmHvqpDn9eYqDehK4tacI&oss_addr=44.92.89.1:8925",
			// 	"image_type": 1,
			// 	"open_result": 1,
			// 	"open_type": 61,
			// 	"person_name": "陈静潮",
			// 	"paper_number": "440524197608167215",
			// 	"capture_time": "2025-12-18 15:42:58",
			// 	"create_time": "2025-12-18 15:43:08",
			// 	"insert_time": "2025-12-18 15:43:08",
			// 	"device": {
			// 		"id": "441399110983464623",
			// 		"name": "东门人员进园2",
			// 		"number": "1000184",
			// 		"longitude": "0.000000",
			// 		"latitude": "0.000000",
			// 		"type": 2,
			// 		"is_security_check": 0,
			// 		"state": 1,
			// 		"entrances_type": 1,
			// 		"state_update_time": "2025-12-18 01:00:09",
			// 		"lane_number": 0,
			// 		"create_user_id": "0",
			// 		"update_user_id": "0",
			// 		"create_time": "2025-03-26 01:00:04",
			// 		"update_time": "2025-03-26 01:00:04",
			// 		"deleted": 0,
			// 		"access_type": 1
			// 	}
			// },]
      tableData.value = data.list
      pagination.value.total = data.total
    })
  }

  const handleRow = (record) => {
    return {
      ondblclick: (event) => {
        event.stopPropagation()
        handleRowDblClick(record)
      },
    }
  }

  // 2、双击行查看详情
  const detailModalVisible = ref(false)
  const detailData = ref(null)
  const detailLoading = ref(false)

  function handleRowDblClick(record) {
    // 从记录中获取所需参数
    const paperNumber = record.paper_number
    const captureTime = record.capture_time
    
    // 调用接口获取详情
    detailLoading.value = true
    detailData.value = null

  //   detailData.value = {
	// 	"person_application_id": "441399113161728657",
	// 	"application_number": "DYWXY20250211000359",
	// 	"visitor_name": "程超",
	// 	"visitor_gender": 0,
	// 	"visitor_nation": "",
	// 	"visitor_education": "",
	// 	"veteran": 0,
	// 	"visitor_face_photo": "http://8.138.26.248:1082/weed/25,01b8f83e7226b8.jpg",
	// 	"visitor_idcard_type": 1,
	// 	"visitor_idcard": "421125198812098233",
	// 	"visitor_phone": "15827296522",
	// 	"visitor_type": 2,
	// 	"visitor_address": "惠州市大亚湾区惠州港疏港大道3号兴盛油库409",
	// 	"visitor_company": "惠州兴盛石化仓储有限公司",
	// 	"visitor_idcard_photo1": "23,01b9163441e225.jpg",
	// 	"visitor_idcard_photo2": "22,01b932c6272a91.jpg",
	// 	"visit_area": 2,
	// 	"visit_begin_time": "2025-02-11",
	// 	"visit_end_time": "2026-02-12",
	// 	"visit_content": "",
	// 	"interviewee_name": "",
	// 	"interviewee_depart_id": "632055545506824210",
	// 	"interviewee_phone": null,
	// 	"state": 2,
	// 	"process_instance_id": "0",
	// 	"is_delayed": 0,
	// 	"delay_reason": "",
	// 	"create_time": "2025-02-11 00:00:00",
	// 	"update_time": "2025-02-11 00:00:00",
	// 	"create_user_id": "0",
	// 	"deleted": 0,
	// 	"wx_unionid": "",
	// 	"is_bulk_import": 0,
	// 	"revoke_reason": "",
	// 	"update_user_id": "0",
	// 	"disagree_reason": "",
	// 	"submit_time": null,
	// 	"approve_time": null
	// }
  // detailModalVisible.value = true
    
    queryPersonApplicationRecord({
      paperNumber,
      captureTime
    }).then(({ data }) => {
      detailLoading.value = false
      if (data) {
        detailData.value = data
        detailModalVisible.value = true
      } else {
        message.warning('未找到相关申请记录')
      }
    }).catch(error => {
      detailLoading.value = false
    })
  }
  
  const cachedSearchParams = computed(() => store.state.search.searchGatePerson)
  onMounted(() => {
    for (const key in cachedSearchParams.value) {
      searchFormRef.value.formState[key] = cachedSearchParams.value[key]
    }
    fetch()
  })
</script>
